<script>
import { mapState, mapActions } from 'pinia'
import paginationMixin from '@/mixins/paginationMixin.js'
import { useFundraiserCategoryStore } from '@/stores/fundraiserCategory.js'
import TwButton from '@/components/generic/tw-button.vue'
import fetchDataMixin from '@/mixins/fetchDataMixin.js'

export default {
  name: 'FundraiserCategoriesRow',
  components: { TwButton },
  mixins: [fetchDataMixin, paginationMixin],
  props: {
    fundraiserCategorySelected: {
      type: Object,
      default: null
    },
    featured: {
      type: Boolean,
      default: false
    }
  },
  emits: ['fundraiserCategorySelected'],
  computed: {
    ...mapState(useFundraiserCategoryStore, ['getItems'])
  },
  mounted() {
    this.fetch()
  },
  methods: {
    ...mapActions(useFundraiserCategoryStore, ['fetchItems']),
    fetch () {
      this.fetchData(this.fetchItems, {
        not_paginated: true,
        ...(this.featured && {featured: this.featured })
      })
    }
  }
}
</script>

<template>
  <div class="flex rounded-md shadow-sm justify-center gap-1">
    <tw-button :variant="fundraiserCategorySelected === null? 'primary':'light'" @click="$emit('fundraiserCategorySelected', null)">
      All
    </tw-button>
    <tw-button v-for="fundraiserCategoryLoop in getItems" :key="'fundraiser-category-key-' + fundraiserCategoryLoop.id" :variant="fundraiserCategorySelected && fundraiserCategorySelected.id === fundraiserCategoryLoop.id ? 'primary':'light'" aria-current="page" class="" @click="$emit('fundraiserCategorySelected', fundraiserCategoryLoop)">
      {{ fundraiserCategoryLoop.name }} <span class="bg-blue-100 text-blue-800 text-xs font-medium me-1 px-2.5 py-0.5 rounded"> {{ fundraiserCategoryLoop.fundraisers_featured_count }} </span>
    </tw-button>
  </div>
</template>

<style scoped>

</style>
